/* eslint-disable */
import React, { useContext, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ConfigContext } from '../context/config.context';
import * as RootNavigation from './navigation-rol/navigation';

const RolNavigation = {
  1: RootNavigation.AdminNavigation,
  2: RootNavigation.GestorNavigation,
  3: RootNavigation.MasterNavigation,
}

const Menu = () => {

  const history = useHistory();
  const [pathname, setPathname] = useState('/dashboard');
  const { config , rol } = useContext(ConfigContext);

  const navigate = (path) => {
    history.push(path);
    setPathname(path);
  }

  const MainNavigation = useMemo(() => RolNavigation[rol],[rol]);

  return (
   <div className="left-sidebar">
    {config !== null ?
     <>
      <MainNavigation navigate={navigate} config={config} pathname={pathname} />
     </>
     : null }
   </div>
  )
}

export default Menu;